import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext'; // ✅ Import the new provider
import { AchievementProvider } from './context/AchievementContext';

// Import all your page and component files...
import ScrollToTop from "./pages/ScrollToTop";
import Home from './pages/Home';
import Tutorials from "./pages/Tutorials";
import TutorialCourse, { LegacyTutorialSubject } from "./pages/TutorialCourse";
import TutorialChapter from "./pages/TutorialChapter";
import { TUTORIAL_SUBJECTS, TUTORIAL_TEST_ROUTES } from "./config/tutorialCatalogue";
import Career from "./pages/career";
import BiologyPlaceholder from "./pages/BiologyPlaceholder";
import DoubtPortal from "./pages/doubtPortal";

import Privacy from "./components/privacy";
import Terms from "./components/terms-condition";
import Refund from "./components/cancel_refund";
import Shipping from "./components/shipping_policy";
import IITJEESyllabus from "./pages/syllabus/IITJEESyllabus";
import NEETSyllabus from "./pages/syllabus/NEETSyllabus";
import CBSEClass10Syllabus from "./pages/syllabus/CBSEClass10Syllabus";
import CBSEClass12Syllabus from "./pages/syllabus/CBSEClass12Syllabus";
import ExamInfo from "./pages/ExamInfo";
import StudyMaterial from "./components/StudyMaterial";
import CheatsheetViewer from "./pages/CheatsheetViewer";
import ChapterNotesPage from "./pages/ChapterNotesPage";

import SchoolHomePage from "./pages/school/SchoolHomePage";
import SchoolChapterNotesPage from "./pages/SchoolChapterNotesPage";
import PYQs from './pages/PYQs';
import PYQ_YearWise from './components/PYQ_YearWise';
import ContactUs from './pages/ContactUs';
import MeetOurTeam from './pages/MeetOurTeam';
import AboutPrrepX from './pages/AboutPrrepX';
import After12 from './pages/after12';
import Login from './pages/Login';
import Profile from "./pages/Profile";
import CommunityPage from './pages/communityPage';
import Signup from './pages/Signup';
import ConfidentialSupport from "./pages/ConfidentialSupport";
import AdminDishaChats from './pages/AdminDishaChats';
import UserManagementDashboard from './pages/UserManagementDashboard';

import QSetRelation from "./pages/iitjee-pyq/mathematics/QSetRelation";
import QLogarithm from "./pages/iitjee-pyq/mathematics/QLogarithm";
import QQuadraticEquation from "./pages/iitjee-pyq/mathematics/QQuadraticEquation";

import Navbar from './components/Navbar';
import PageMeta from './components/PageMeta';
import './App.css';

//test series
import JEE2020_1_1 from "./pages/test-series/jee2020_1_1";
import PhysicsTest from "./pages/test-series/physics_test";
import ChemistryTest from "./pages/test-series/chemistry_test";
import BiologyTest from "./pages/test-series/Biology_test";

function App() {
  return (
    // ✅ Wrap the entire application with AuthProvider
    <AuthProvider>
      <AchievementProvider>
      <Router>
        <PageMeta />
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/tutorials/course/:programId" element={<TutorialCourse />} />
          <Route path="/tutorials/course/:programId/:subjectKey/:chapterId" element={<TutorialChapter />} />
          {TUTORIAL_SUBJECTS.map(subject => (
            <Route key={subject.subjectKey} path={subject.route} element={<LegacyTutorialSubject subjectKey={subject.subjectKey} />} />
          ))}
          <Route path="/tutorials/biology-placeholder" element={<BiologyPlaceholder />} />
          <Route path="/prepxpathshala-school" element={<SchoolHomePage />} />
          <Route path="/school-notes/:programKey/:chapter" element={<SchoolChapterNotesPage />} />
          <Route path="/pyqs/chapterwise" element={<PYQs />} />
          <Route path="/pyqs/yearwise" element={<PYQ_YearWise />} />
          <Route path="/enquiry-now" element={<ContactUs />} />
          <Route path="/meetourteam" element={<MeetOurTeam />} />
          <Route path="/meet-our-team" element={<Navigate to="/meetourteam" replace />} />
          <Route path="/about-prrepx" element={<AboutPrrepX />} />
          <Route path="/after12" element={<After12 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/shipping-policy" element={<Shipping />} />
          <Route path="/confidential-support" element={<ConfidentialSupport />} />
          <Route path="/doubt-portal24*7" element={<DoubtPortal />} />
          <Route path="/community-page" element={<CommunityPage />} />
          <Route path="/community" element={<Navigate to="/community-page" replace />} />

          <Route path="/study-materials" element={<StudyMaterial />} />
          <Route path="/cheatsheet/:filename" element={<CheatsheetViewer />} />
          <Route path="/complete-notes" element={<Navigate to="/study-materials#chapterwise-notes" replace />} />
          <Route path="/notes/:subject/:chapter" element={<ChapterNotesPage />} />



          {/* ✅ Dashboard & Admin Routes */}
            <Route path="/admin/disha" element={<AdminDishaChats />} />
            <Route path="/user-management" element={<UserManagementDashboard />} />

          <Route path="/iitjee-syllabus" element={<IITJEESyllabus />} />
          <Route path="/neet-syllabus" element={<NEETSyllabus />} />
          <Route path="/cbse10th-syllabus" element={<CBSEClass10Syllabus />} />
          <Route path="/cbse12th-syllabus" element={<CBSEClass12Syllabus />} />
          <Route path="/exam-guide" element={<ExamInfo />} />

          <Route path="/pyqs/mathematics/sets-relations-functions" element={<QSetRelation />} />
          <Route path="/pyqs/mathematics/logarithms" element={<QLogarithm />} />
          <Route path="/pyqs/mathematics/quadratic-equations" element={<QQuadraticEquation />} />
            
            {/* ✅ ADD Test Series paths*/}
          <Route path={TUTORIAL_TEST_ROUTES.jee2020_1_1} element={<JEE2020_1_1 />} />
          
          <Route path="/test/physics-hiring" element={<PhysicsTest />} />
          <Route path="/test/chemistry-hiring" element={<ChemistryTest />} />
          <Route path="/test/biology-hiring" element={<BiologyTest />} />
          
        </Routes>
        <Analytics />
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover draggable theme="light" />
      </Router>
      </AchievementProvider>
    </AuthProvider>
  );
}

export default App;
